import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AnnouncementDetails } from '../shared/models/announcement-details-model';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/root-store/state';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  apply,
  copyAnnouncementLink,
  getAnnDetailsPageBannerList,
  getAnnouncementViewCounts,
  loadAnnouncementDetails,
  loadNavigationIds,
  sendAnnouncementViewToAnalytic,
  showCvBoxSlider,
} from 'src/app/root-store/announcement-store/ann-details-page/actions';
import { combineLatest, Observable, Subscription } from 'rxjs';
import {
  selectAnnouncementDetails,
  selectBackToSearchResultRouterLink,
  selectBackToSearchResultQueryParams,
  getNextAnnouncementId,
  getPreviousAnnouncementId,
  selectAnnouncementPublishDate,
  selectAnnouncementNotFound,
  selectSimilarAnnouncements,
  selectIsAnnouncementDetailsLoading,
  selectAnnouncementDetailsMetaData,
  selectAnnDetailsTopBanner,
  selectAnnDetailsRightBanner,
  selectAnnDetailsRightBanner2,
  selectAnnDetailsSquareBanner,
  selectAnnDetailsMiddleBanner,
  selectAnnDetailsBottomBanner,
  selectAnnDetailsStateInfo,
  selectIsAnnDetailsCvBoxSliderVisible,
  selectAnnouncementDesktopImage,
  selectAnnouncementMobileImage,
  ownAnnouncements,
  selectAnnDetailsRightBanner3,
  selectAnnDetailsPageBannerIds,
  selectAnnouncementViewStats,
  selectLastAnnouncementId,
  selectIsAnnouncementLinkCopied,
  selectAnnDetailsIsJobseekerInvited,
  selectAnnDetailsInvitedJobseeker,
} from 'src/app/root-store/announcement-store/ann-details-page/selectors';
import {
  ApplicationMethodEnum,
  AnnouncementInviteResponseEnum,
  AnnouncementInvitedJobseeker,
  AnnouncementInviteViewStatusEnum,
  UserTypeEnum,
} from '@hrra/common-models';
import { markInviteViewed, respondToInvite } from 'src/app/root-store/jobseeker-store/jobseeker-applies/actions';
import { User } from 'src/app/user/shared/models/user-model';
import * as selectors from 'src/app/root-store/selectors';
import { PageNameEnum } from 'src/app/shared/models/enums/page-names-enum';
import {
  AnnouncementFilterQueryParams,
  AnnouncementService,
} from 'src/app/shared/services/announcement.service';
import { filter, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { RelatedAnnouncement } from '../shared/models/similar-announcement-model';
import {
  addToFavorites,
  loadLastListingPage,
  removeFromFavorites,
  sendBannerViewToAnalytic,
} from 'src/app/root-store/actions';
import { CvBox } from 'src/app/cv-box/shared/models/cv-box-model';
import {
  selectCvBoxes,
} from 'src/app/root-store/cv-box-store/selectors';
import { loadFrontPageCvBoxes } from 'src/app/root-store/cv-box-store/actions/cv-box-front-page-actions';
import {
  selectIsCustomerSignedIn,
  selectIsJobseekerSignedIn,
  selectTimeZone,
  selectCurrency,
  selectCurrentLanguage,
  selectCurrentWebsite,
  selectCurrentUserType,
  selectSocialMediaShareLinks,
} from 'src/app/root-store/selectors';
import { MetaService } from 'src/app/shared/services/meta.service';
import { Banner } from 'src/app/banner/shared/models/banner-model';
import { BannerTargetEnum } from 'src/app/banner/shared/models/enums/banner-target-enum';
import { BannerPositionEnum } from 'src/app/banner/shared/models/enums/banner-position-enum';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { ErrorTypeEnum } from '@hrra/ui';
import { Breakpoints } from 'src/app/shared/models/breakpoints-model';
import { SsrService } from '@hrra/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { getOwlOptions } from 'src/app/shared/helpers/cv-box-slider-otions ';
import { Announcement } from '../shared/models/announcement-model';
import { CurrentNavigation } from 'src/app/root-store/announcement-store/ann-details-page/state';
import { TranslitService } from 'src/app/shared/services/translit.service';
import { BannerHeaderPositionId } from 'src/app/shared/models/enums/banner-header-position-id-enum';
import { AnnouncementStats } from '../shared/models/announcement-view-stats.model';
import {
  selectFrontAnnouncementPage,
  selectHasMorePages,
} from 'src/app/root-store/announcement-store/selectors';
import { loadFrontPageAnnouncements } from 'src/app/root-store/announcement-store/announcement-front-page-actions';
import { DeviceDetectionService, EnvService } from '@hrra/core';
import { SocialMediaShareSystemConfig } from 'src/app/shared/models/system-config-model';
import { MatDialog } from '@angular/material/dialog';
import { JobseekerLoginRegistrationDialogComponent } from 'src/app/jobseeker/jobseeker-login-registration-dialog/jobseeker-login-registration-dialog.component';
import { JobseekerPopupEnum } from 'src/app/jobseeker/shared/models/enums/jobseeker-popup-enum';

@Component({
  selector: 'app-ann-details-page',
  templateUrl: './redesign/ann-details-page.component.html',
  styleUrls: ['./redesign/ann-details-page.component.scss'],
  standalone: false,
})
export class AnnDetailsPageComponent implements OnInit, OnDestroy {
  currentLanguage$: Observable<string>;

  metaDataSubscription: Subscription;

  pageId: any;

  target: any;
  targetId: number = BannerTargetEnum.Desktop;
  cvBoxSliderOptions: OwlOptions;

  public applicationMethod: any;
  public pageName: any;
  public errorType: any;
  public userTypeEnum = UserTypeEnum;

  public isAnnouncementLinkCopied$: Observable<boolean>;

  public socialMediaShareLinks$: Observable<SocialMediaShareSystemConfig>;

  providerWebsiteId: any;

  public routerLink$: Observable<string>;
  public queryParams$: Observable<Params>;
  public nextAnnouncementId$: Observable<CurrentNavigation>;
  public previousAnnouncementId$: Observable<CurrentNavigation>;
  public publishDate$: Observable<Date>;
  public announcementNotFound$: Observable<boolean>;
  public timeZone$: Observable<string>;

  public selectNextPage$: Observable<number>;
  public selectLastAnnouncementId$: Observable<number>;
  public selectHasMorePages$: Observable<boolean>;

  public filterEnum: any;

  public lastListingPage: PageNameEnum;

  public currency$: Observable<string>;

  public announcementViewStats$: Observable<AnnouncementStats>;

  public viewStatusEnum = AnnouncementInviteViewStatusEnum;

  announcementDetails$: Observable<AnnouncementDetails>;
  isJobseekerInvited$: Observable<boolean>;
  announcementInvitedJobseeker$: Observable<AnnouncementInvitedJobseeker>;
  isSignedIn$: Observable<boolean>;
  isJobseekerSignedIn$: Observable<boolean>;
  isCustomerSignedIn$: Observable<boolean>;
  user$: Observable<User>;
  similarAnnouncementList$: Observable<RelatedAnnouncement[]>;
  favoriteAnnouncementsMap$: Observable<{ [index: number]: boolean }>;
  cvBoxes$: Observable<CvBox[]>;

  isLoading$: Observable<boolean>;

  topBanner$: Observable<Banner>;
  rightBanner$: Observable<Banner>;
  rightBanner2$: Observable<Banner>;
  rightBanner3$: Observable<Banner>;
  rightBannerSquare$: Observable<Banner>;
  middleBanner$: Observable<Banner>;
  bottomBanner$: Observable<Banner>;

  isCvBoxSliderVisible$: Observable<boolean>;

  desktopImage$: Observable<string>;
  mobileImage$: Observable<string>;
  ownAnnouncements$: Observable<Announcement[]>;

  userType$: Observable<any>;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private announcementService: AnnouncementService,
    private translate: TranslateService,
    private metaService: MetaService,
    private dialogService: DialogService,
    private ssr: SsrService,
    private deviceDetectionService: DeviceDetectionService,
    public translit: TranslitService,
    private envService: EnvService,
    private ngZone: NgZone,
    private dialog: MatDialog
  ) {
    this.cvBoxSliderOptions = getOwlOptions();
    this.applicationMethod = ApplicationMethodEnum;
    this.pageName = PageNameEnum;
    this.errorType = ErrorTypeEnum;
    this.target = BannerTargetEnum;
    this.filterEnum = AnnouncementFilterQueryParams;
    // this.targetId =
    //   window.innerWidth > Breakpoints.medium
    //     ? BannerTargetEnum.Desktop
    //     : BannerTargetEnum.Responsive;
    this.pageId = BannerHeaderPositionId;
  }

  public onToggleFavorite(announcementId: number, isFavorite: boolean) {
    if (isFavorite) {
      this.store.dispatch(
        removeFromFavorites({ payload: { announcementId: announcementId } })
      );
    } else {
      this.store.dispatch(
        addToFavorites({ payload: { announcementId: announcementId } })
      );
    }
  }

  public copyCurrentRoute() {
    if (this.ssr.isPlatformBrowser()) {
      const fullUrl = window.location.href; // includes the locale prefix (router.url is prefix-stripped)

      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          this.ngZone.run(() => {
            this.store.dispatch(copyAnnouncementLink());
            setTimeout(() => this.store.dispatch(copyAnnouncementLink()), 1500);
          });
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
        });
    }
  }

  public shareOnSocialMedia(socMediaUrlTemplate: string) {
    if (this.ssr.isPlatformBrowser) {
      const fullUrl = window.location.href; // includes the locale prefix (router.url is prefix-stripped)
      const socMediaShareUrl = socMediaUrlTemplate.replace(
        '{URL}',
        encodeURIComponent(fullUrl)
      );

      window.open(socMediaShareUrl, '_blank', 'noopener,noreferrer');
    }
  }

  redirectToUrl(isJobseekerSignedIn: boolean, hasCaptureCv: boolean, url: string) {
    if (isJobseekerSignedIn || !hasCaptureCv) {
      window.open(url, '_blank');
    } else {
      const dialogRef = this.dialog.open(
        JobseekerLoginRegistrationDialogComponent,
        {
          width: '480px',
          data: { 
            selectedTab: JobseekerPopupEnum.Login,
            applyMethod: ApplicationMethodEnum.RedirectToUrl
           },
        }
      );
    }

  }

  ngOnInit(): void {
    this.providerWebsiteId = this.envService.tenantId;

    const deviceInfo = this.deviceDetectionService.detectDevice();

    this.targetId =
      deviceInfo.isDesktop || deviceInfo.isTablet
        ? BannerTargetEnum.Desktop
        : BannerTargetEnum.Responsive;

    this.store.dispatch(
      loadLastListingPage({ payload: PageNameEnum.AnnouncementDetails })
    );
    this.isCvBoxSliderVisible$ = this.store.pipe(
      select(selectIsAnnDetailsCvBoxSliderVisible)
    );

    this.currentLanguage$ = this.store.pipe(select(selectCurrentLanguage));

    if (this.ssr.isPlatformBrowser()) {
      this.store.dispatch(
        getAnnDetailsPageBannerList({
          payload: {
            targetId: this.targetId,
            bannerHeadId: BannerPositionEnum.Announcement_details,
          },
        })
      );
      this.store.dispatch(showCvBoxSlider({ payload: true }));
    }

    let paramMap$ = this.route.paramMap;
    let annDetailsState$ = this.store.pipe(
      select(selectAnnDetailsStateInfo),
      filter((c) => c.pageSize !== undefined && c.isLookupLoaded),
      take(1)
    );
    let queryParamMap$ = this.route.queryParamMap;

    let annDetailsPageBanners$ = this.store.select(
      selectAnnDetailsPageBannerIds
    );
    let providerWebsiteId$ = this.store.select(selectCurrentWebsite);

    combineLatest([annDetailsPageBanners$, providerWebsiteId$])
      .pipe(
        filter(([banners, provderWebsite]) => {
          return (
            banners.bannerIdList.length > 0 &&
            provderWebsite !== null &&
            provderWebsite !== undefined
          );
        }),
        take(1)
      )
      .subscribe(([b, p]) => {
        this.store.dispatch(
          sendBannerViewToAnalytic({
            payload: {
              bannerIdList: b,
              providerWebsiteId: p.providerWebsiteId,
              pageId: BannerHeaderPositionId.FrontPage,
            },
          })
        );
      });

    // this.route.paramMap.pipe(
    combineLatest([paramMap$, queryParamMap$, annDetailsState$]).subscribe(
      ([p, q, s]) => {
        let id = +p.get('id');
        let urlTitle = p.has('title') ? p.get('title') : null;

        let payload = { announcementId: id, urlTitle: urlTitle };

        if (q.has('nav')) {
          payload['nav'] = q.get('nav');
        }
        this.store.dispatch(loadAnnouncementDetails({ payload: payload }));

        this.store.dispatch(loadFrontPageCvBoxes());

        if (this.ssr.isPlatformBrowser()) {
          this.store.dispatch(
            getAnnouncementViewCounts({ payload: { announcementId: id } })
          );
        }

        //previous/next announcement
        let directNavigation = !q.has('nav');

        if (s.lastListingPage == PageNameEnum.SearchResultsPage) {
          let start: number;
          let index: number;

          let tmpNavigationIds = s.search.announcements.map(
            (e) => e.announcementId
          );
          let itemsPerPage = s.pageSize;
          let currentPage = s.search.filter.currentPage;

          if (directNavigation) {
            start = (currentPage - 1) * itemsPerPage;
          } else {
            tmpNavigationIds = s.annDetails.currentNvaigationIds.map(
              (values) => values.announcementId
            );
            start = s.annDetails.start;
          }

          index = tmpNavigationIds.indexOf(id);

          let isLast =
            (currentPage - 1) * itemsPerPage + index ==
            s.search.matchedAnnouncementCount - 1;

          if (index == tmpNavigationIds.length - 1 && !isLast) {
            let newStart = start + (itemsPerPage - 2);

            if (newStart > s.search.matchedAnnouncementCount - 1) {
              start = s.search.matchedAnnouncementCount - (itemsPerPage - 1);
            } else {
              start = newStart;
            }
          }

          if (index == 0) {
            let newStart = start - (itemsPerPage - 1);
            if (newStart < 0) {
              start = 0;
            } else {
              start = newStart;
            }
          }

          let filter = s.search.filter;
          let fullFilter = this.announcementService.convertFilterToFullFilter(
            filter,
            s.lookup,
            itemsPerPage
          );

          fullFilter.start = start;

          this.store.dispatch(
            loadNavigationIds({ payload: { filter: fullFilter, start: start } })
          );
        }

        this.metaDataSubscription = this.store
          .pipe(select(selectAnnouncementDetailsMetaData))
          .subscribe((data) => {
            this.metaService.updateMetaData(data?.website, data?.metaData);
          });
      }
    );

    this.announcementDetails$ = this.store.pipe(
      select(selectAnnouncementDetails)
    );

    this.isJobseekerInvited$ = this.store.select(
      selectAnnDetailsIsJobseekerInvited
    );
    this.announcementInvitedJobseeker$ = this.store.select(
      selectAnnDetailsInvitedJobseeker
    );

    this.isSignedIn$ = this.store.select(selectors.selectIsSignedIn);
    this.isJobseekerSignedIn$ = this.store.pipe(
      select(selectIsJobseekerSignedIn)
    );
    this.isCustomerSignedIn$ = this.store.pipe(
      select(selectIsCustomerSignedIn)
    );
    this.user$ = this.store.pipe(select(selectors.selectUser));

    this.routerLink$ = this.store.pipe(
      select(selectBackToSearchResultRouterLink)
    );
    this.queryParams$ = this.store.pipe(
      select(selectBackToSearchResultQueryParams)
    );

    this.nextAnnouncementId$ = this.store.pipe(select(getNextAnnouncementId));
    this.previousAnnouncementId$ = this.store.pipe(
      select(getPreviousAnnouncementId)
    );
    this.publishDate$ = this.store.pipe(select(selectAnnouncementPublishDate));

    this.similarAnnouncementList$ = this.store.pipe(
      select(selectSimilarAnnouncements)
    );
    this.announcementNotFound$ = this.store.pipe(
      select(selectAnnouncementNotFound)
    );

    this.favoriteAnnouncementsMap$ = this.store.pipe(
      select(selectors.selectFavoriteAnnouncementsMap)
    );

    this.isAnnouncementLinkCopied$ = this.store.select(
      selectIsAnnouncementLinkCopied
    );

    this.selectNextPage$ = this.store.select(selectFrontAnnouncementPage);
    this.selectHasMorePages$ = this.store.select(selectHasMorePages);
    this.selectLastAnnouncementId$ = this.store.select(
      selectLastAnnouncementId
    );

    combineLatest([
      this.selectHasMorePages$,
      this.selectLastAnnouncementId$,
      this.selectNextPage$,
      paramMap$,
    ])
      .pipe(take(1))
      .subscribe(([hasMorePage, isLastAnnouncement, nextPage, paramMap]) => {
        const id = +paramMap.get('id');
        if (hasMorePage && +isLastAnnouncement === id) {
          this.store.dispatch(
            loadFrontPageAnnouncements({
              payload: { page: nextPage, targetId: this.targetId },
            })
          );
        }
      });

    this.cvBoxes$ = this.store.pipe(
      select(selectCvBoxes)
    );

    this.isLoading$ = this.store.pipe(
      select(selectIsAnnouncementDetailsLoading)
    );

    this.timeZone$ = this.store.pipe(select(selectTimeZone));

    this.topBanner$ = this.store.pipe(select(selectAnnDetailsTopBanner));
    this.rightBanner$ = this.store.pipe(select(selectAnnDetailsRightBanner));
    this.rightBanner2$ = this.store.pipe(select(selectAnnDetailsRightBanner2));
    this.rightBanner3$ = this.store.pipe(select(selectAnnDetailsRightBanner3));
    this.rightBannerSquare$ = this.store.pipe(
      select(selectAnnDetailsSquareBanner)
    );
    this.middleBanner$ = this.store.pipe(select(selectAnnDetailsMiddleBanner));
    this.bottomBanner$ = this.store.pipe(select(selectAnnDetailsBottomBanner));

    this.desktopImage$ = this.store.pipe(
      select(selectAnnouncementDesktopImage)
    );
    this.mobileImage$ = this.store.pipe(select(selectAnnouncementMobileImage));
    this.ownAnnouncements$ = this.store.pipe(select(ownAnnouncements));
    this.announcementViewStats$ = this.store.pipe(
      select(selectAnnouncementViewStats)
    );

    this.socialMediaShareLinks$ = this.store.select(
      selectSocialMediaShareLinks
    );

    this.currency$ = this.store.select(selectCurrency);

    this.userType$ = this.store.select(selectCurrentUserType);

    this.announcementInvitedJobseeker$
      .pipe(
        filter((jobseeker): jobseeker is AnnouncementInvitedJobseeker => jobseeker != null),
        take(1)
      )
      .subscribe((announcementInvitedJobseeker) => {
        const inviteId = announcementInvitedJobseeker.announcementInvitedJobseekerId
        const isNew = announcementInvitedJobseeker.viewStatus === this.viewStatusEnum.New

        if(isNew){
          this.store.dispatch(
            markInviteViewed({
              payload: { inviteId },
            })
          );
        }
      });
  }

  ngOnDestroy() {
    if (this.metaDataSubscription) {
      this.metaDataSubscription.unsubscribe();
    }
  }

  onSpecializationClick(specializationCode: number) {
    const query = {};
    const spArray = [`${specializationCode}`];
    const spString = JSON.stringify(spArray);
    const specializationParam = this.filterEnum.Specializations;

    query[specializationParam] = spString;

    this.router.navigate(['./search-posting'], {
      queryParams: query,
    });
  }

  public onInviteRespond(response: {
    responseStatus: AnnouncementInviteResponseEnum;
    inviteId: number;
    applicationMethod: ApplicationMethodEnum;
  }): void {
    this.dialogService
      .openInviteRespondConfirmDialog(response.responseStatus, response.applicationMethod, true)
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.store.dispatch(
            respondToInvite({
              payload: {
                inviteId: response.inviteId,
                responseStatus: response.responseStatus,
              },
            })
          );
        }
      });
  }

  onCvSend(
    announcementId: number,
    isSignedIn: boolean,
    isJobseekerSignedIn: boolean
  ) {
    if (!isSignedIn) {
      this.dialog.open(
        JobseekerLoginRegistrationDialogComponent,
        {
          width: '480px',
          data: { 
            selectedTab: JobseekerPopupEnum.Login,
            applyMethod: ApplicationMethodEnum.ViaWebsite
           },
        }
      );
    } else if (isJobseekerSignedIn) {
      this.dialogService
        .openConfirmDialog('message.AreYouSure')
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.store.dispatch(
              apply({ payload: { announcementId: announcementId } })
            );
          }
        });
    }
  }
}
